import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showAddMessage: '='
    },
    template: `
    <div class="alert alert-plain">
        <h3>{{ 'general.This table has no content yet' | translate }}</h3>
        <p ng-if="vm.showAddMessage">{{ 'general.Please add some content' | translate }}</p>
    </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/list/noContent/index.js